import * as yup from "yup";

import { FormId } from "../../../../../components/enums";
import {
  cityValidator,
  countryValidator,
  dateValidatorRequired,
  postalCodeGenericValidator,
  postalCodePolandValidator,
  provinceValidator,
  textareaValidator,
  textareaValidatorRequired,
  timeValidatorRequired,
} from "../../../../../utilities/validators";

import { ComponentId } from "./enums";

export const validator = {
  [FormId.INCIDENT_CIRCUMSTANCES]: yup.object({
    [ComponentId.DATE]: dateValidatorRequired,
    [ComponentId.HOUR]: timeValidatorRequired,
    [ComponentId.PLACE]: textareaValidatorRequired(250),
    [ComponentId.ZIP_CODE_PL]: postalCodePolandValidator,
    [ComponentId.ZIP_CODE_GENERIC]: postalCodeGenericValidator,
    [ComponentId.CITY]: cityValidator,
    [ComponentId.COUNTRY]: countryValidator,
    [ComponentId.PROVINCE]: provinceValidator,
    [ComponentId.DESCRIPTION]: textareaValidator(2000),
  }),
};
